import SelectOption from '@/models/interface/SelectOption'

export default [
  {
    key: 'checkbox',
    label: '',
    sortable: false,
    show: true,
    type: 'checkbox',
    class: 'align-middle',
  },
  {
    key: 'id',
    label: 'ID',
    thClass: 'align-middle text-center',
    sortable: true,
    show: false,
    class: 'align-middle text-center',
  },
  {
    key: 'name',
    label: 'Name',
    thClass: 'align-middle text-center',
    sortable: true,
    show: true,
    class: 'align-middle',
  },
  {
    key: 'type',
    label: 'Type',
    thClass: 'align-middle text-center',
    sortable: true,
    show: true,
    class: 'align-middle text-center text-capitalize',
  },
  {
    key: 'connection',
    label: 'Connection',
    thClass: 'align-middle text-center',
    sortable: true,
    show: true,
    class: 'align-middle text-center',
  },
  {
    key: 'remote_id',
    label: 'Remote ID',
    thClass: 'align-middle text-center',
    sortable: true,
    show: true,
    class: 'align-middle text-center',
  },
  {
    key: 'owner_id',
    label: 'Owner',
    thClass: 'align-middle text-center',
    sortable: true,
    show: true,
    class: 'align-middle text-center',
  },
  {
    key: 'company_id',
    label: 'Company',
    thClass: 'align-middle text-center',
    sortable: true,
    show: true,
    class: 'align-middle text-center',
    thStyle: 'width: 30rem',
  },
  {
    key: 'status',
    label: 'Status',
    thClass: 'align-middle text-center',
    sortable: true,
    show: true,
    class: 'align-middle text-center',
    type: 'badge',
    color: (item: any) => {
      if (item.status == 'pending') {
        return 'warning'
      }
      return 'success'
    },
  },
  {
    key: 'action',
    label: false,
    sortable: false,
    class: 'text-center align-middle',
    type: 'action_list',
    show: (e: any) => e.company_id && e.id,
    actions: [
      {
        icon: 'pencil',
        title: 'Edit',
        event: 'edit',
        action: (e: any) => {
          e.add_company = true
        },
      },
    ],
  },
]
